export default __webpack_public_path__ + "static/media/OrangeStar.1ea00c10.svg";